<template>
  <div class="mt-10 home-search">
    <ul class="home-search__list p-0">
      <li class="home-search__item">
        <a
          href="#"
          @click.prevent="toggleSearchType('village')"
          class="home-search__link"
          :class="{ 'home-search__link--selected': selectedSearchType === 'village'}"
        >Retirement Villages</a>
      </li>
      <li class="">
        <a
          href="#"
          @click.prevent="toggleSearchType('restHome')"
          class="home-search__link"
          :class="{ 'home-search__link--selected': selectedSearchType === 'restHome'}"
        >Rest Homes</a>
      </li>
    </ul>
    <div class="d-none d-lg-flex flex-row home-search__fields">
<!--      <input-->
<!--        type="text"-->
<!--        name="keyword"-->
<!--        v-model="keywordInput"-->
<!--        class="home-search__fields-keyword"-->
<!--        placeholder="Search by location or keyword"-->
<!--      >-->
      <SearchAutocomplete
        @itemSelected="onItemSelected"
        @submitSearch="submitSearch"
        :placeholder="searchPlaceHolder"
        :search-type="selectedSearchType"
      />
<!--      <button class="home-search__fields-filter"><i class="icon-search-filter mr-4"></i> Filters</button>-->
<!--      <button class="home-search__fields-search" @click="submitSearch">Search</button>-->
    </div>

    <div class="d-lg-none flex-row home-search__fields">
      <div class="position-relative mb-2">
        <SearchAutocomplete
          @itemSelected="onItemSelected" @submitSearch="submitSearch" :placeholder="searchPlaceHolder" :search-type="selectedSearchType" />
<!--        <button class="home-search__fields-filter"><i class="icon-search-filter"></i></button>-->
      </div>
<!--      <button class="home-search__fields-search" @click="submitSearch">Search</button>-->
    </div>
  </div>
</template>
<script>
import SearchAutocomplete from "../SearchAutocomplete";
export default {
  components: {
    SearchAutocomplete
  },
  data() {
    return {
      selectedSearchType: 'village',
      keywordInput: '',
      searchPlaceHolder: 'Search by location or village name',
      selectedItem: '',
    }
  },
  methods: {
    toggleSearchType(type) {
      this.selectedSearchType = type;
      this.searchPlaceHolder = type === 'village' ?
        'Search by location or village name' :
        'Search by location or rest home name';
    },
    onItemSelected(item) {
      this.selectedItem = item;
      this.selectedItemUrl = item.url;
    },
    submitSearch() {
      if (this.selectedItem.type === 'village' || this.selectedItem.type === 'restHome' || this.selectedItem.type === 'operator') {
        window.location.href = this.selectedItem.url;
      } else {
        const urlString = this.selectedSearchType === 'village' ? '/retirement-villages/' : '/rest-homes/';
        window.location.href = `${urlString}${this.selectedItemUrl}`;
      }
    }
  },
};

</script>
